import { useTranslation } from 'react-i18next';

export default function OverseasHeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fce77b3addf9eda54ebe2299d4c293d3.jpg"
          alt="Tokyo Skyline"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="mb-8 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-5xl font-bold text-white mb-2">150+</div>
            <div className="text-sm text-gray-300 uppercase tracking-wider">Properties Managed</div>
          </div>
          <div className="w-px h-16 bg-white/30"></div>
          <div className="text-center">
            <div className="text-5xl font-bold text-white mb-2">98%</div>
            <div className="text-sm text-gray-300 uppercase tracking-wider">Client Satisfaction</div>
          </div>
          <div className="w-px h-16 bg-white/30"></div>
          <div className="text-center">
            <div className="text-5xl font-bold text-white mb-2">24/7</div>
            <div className="text-sm text-gray-300 uppercase tracking-wider">Support Available</div>
          </div>
        </div>

        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Complete Peace of Mind<br />from Overseas.
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-4 max-w-3xl mx-auto leading-relaxed">
          Tokyo Minpaku Full Support for Overseas Owners
        </p>

        <p className="text-lg text-gray-300 mb-12 max-w-2xl mx-auto">
          Run your Tokyo vacation rental business with confidence, no matter where you are in the world. We handle everything from legal compliance to daily operations.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="px-10 py-4 bg-white text-gray-900 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Free Consultation
          </a>
          <a
            href="#services"
            className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            View Our Services
          </a>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-gray-300">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-2xl"></i>
            <span className="text-sm">Licensed & Compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-global-line text-2xl"></i>
            <span className="text-sm">English Support</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-file-text-line text-2xl"></i>
            <span className="text-sm">Monthly Reports</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-bank-line text-2xl"></i>
            <span className="text-sm">Tax Support</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}